import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Routes from 'components/Routes';
import UserIdentification from 'UserIdentification';
import Toast from 'components/Toast';
import Loader from 'components/Loader';
import CallOverlay from 'components/CallOverlay';
import { useChatbotVisibility } from 'hooks/useChatbotVisibility';

const AppContent = () => {
  const location = useLocation();

  // Set route data attribute for CSS targeting
  useEffect(() => {
    document.body.setAttribute('data-route', location.pathname);
    return () => {
      document.body.removeAttribute('data-route');
    };
  }, [location.pathname]);

  // Manage chatbot visibility based on authentication and routes
  useChatbotVisibility();

  return (
    <>
      <Routes />
      <UserIdentification />
      <Toast />
      <Loader />
      <CallOverlay />
    </>
  );
};

export default AppContent;
